"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSextantPlugin = void 0;
var databaseUtilities_1 = require("./databaseUtilities");
var fs = require("fs");
var path = require("path");
var fileSaveUtilities_1 = require("./fileSaveUtilities");
/**
 * Creates a plugin which can be used to print files
 * based on the sextant database
 */
exports.createSextantPlugin = function (implementation) {
    return function plugin(database, config) {
        implementation({
            database: databaseUtilities_1.flattenDatabase(database),
            writeFileSync: function (relativePath, contents) {
                var targetDir = fileSaveUtilities_1.getTargetDir();
                fs.writeFileSync(path.resolve(targetDir, relativePath), contents);
            },
        }, config);
    };
};
